export class UpdateInfoIndividual 
{
    individualId: number|undefined;
    categorie:String;
    customerCode:String;
    customerNumber:String;
    firstname:String;
    lastname:String;
    email:String;
    matricule:String;
    situationMatrimoniale:String;
    adressePostale:String;
    adresseGeographique:String;
    homePhone:String;
    mobilePhone:String;
    codeAgenceDomiciliation:String;
    codeGestionnaireDomiciliation:String;
    rib:String;
    numeroCompte:String;
    libelleAgenceDomiciliation:String;
}